(()=>{document.addEventListener("DOMContentLoaded",function(){let e=atob("ZG9taW5pcXVlQGxhdHNjaGFpbnRlcmlvcnMuY2g="),t=document.getElementById("email-link");t.href="mailto:"+e,t.textContent=e});})();
